import React from 'react'

// Icons
import { ReactComponent as ImagePlaceholder } from '@sketch/icons/document-64'

// Components
import { LoadingPlaceholder } from '@sketch/components'

// Utils
import { getThumbnail } from 'modules/shares/ComponentsWebView/utils'

// Styles
import { ImageElement } from 'modules/shares/components/DocumentItem/DocumentItem.styles'
import {
  StyledStatusIcon,
  Thumbnail,
  ThumbnailWrapper,
  NoThumbnailWrapper,
} from './CollectionItem.styles'

// Types
import { CollectionItemProps } from './types'
import { ShareThumbnailsFragment } from '@sketch/gql-types'

type PreviewThumbnail = NonNullable<
  NonNullable<ShareThumbnailsFragment['thumbnails']>[0]
>

export const renderPreview = (
  props: CollectionItemProps,
  layout: 'grid' | 'list'
) => {
  const { collection } = props

  // Only show the first 4 previews
  const previews = collection.previews.slice(0, 4)

  return (
    <ThumbnailWrapper aria-label={`Collection ${collection.name}`}>
      {previews.map(({ name, file }, index) => {
        const thumbnails = (file?.thumbnails || []).filter(
          thumb => !!thumb
        ) as PreviewThumbnail[]

        if (thumbnails.length === 0) {
          return (
            <NoThumbnailWrapper data-testid="collection-no-thumb" key={index}>
              <StyledStatusIcon
                key={index}
                as={ImagePlaceholder}
                aria-label="No Image available"
              />
            </NoThumbnailWrapper>
          )
        } else {
          return (
            <Thumbnail
              key={index}
              alt={name}
              customImageElement={ImageElement}
              src={getThumbnail(thumbnails)}
              loadingPlaceholder={
                layout === 'grid' ? (
                  <LoadingPlaceholder size="64px" />
                ) : (
                  <LoadingPlaceholder size="16px" />
                )
              }
            />
          )
        }
      })}
    </ThumbnailWrapper>
  )
}
